
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, required, sameAs} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {RecoverPasswordRequestType} from "@/form/recover/recoverPassword/recoverPassword.types";

@Component
export default class RecoverPasswordForm extends Form{
    @Validate(sameAs('password'), i18nText("Пароли не совпадают"))
    @Validate(required, i18nText("Повторите пароль"))
    rpassword = '';
    @Validate(minLength(6), i18nText("Пароль не должен быть меньше 6 символов"))
    @Validate(required, i18nText("Введите пароль"))
    password = '';
    phone = '';
    getFormData(): RecoverPasswordRequestType {
        return {
            confirm_password: this.rpassword,
            password: this.password,
            phone: this.phone,
            token: 'b62e68d04882a310cadb793ec9f62c8028eb0ceb3dc92fa495d87b103cb5c625'
        }
    }
}
